










































































import Vue from 'vue';
import { AxiosResponse } from 'axios';
import mixins from 'vue-typed-mixins';
import { mapState } from 'vuex';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import baseEntityListComponent from '@/Shared/CommonEntityMixins/EntityListComponentMixin';
import { Revenue, RevenueTax } from './Types';
import { LocationLookupType, ILookupType } from '@/Stores/LookupStore';
import Multiselect from 'vue-multiselect';

export default mixins(LocationBasedMixin, baseEntityListComponent<Revenue>()).extend({
    name: 'RevenueTypes',
    components: {
        Multiselect
    },
    async beforeMount() {
        this.taxList = await this.$typedStore.modules.lookupsModule.actions.getLocationLookups({
            location: this.location,
            lookupType: LocationLookupType.Tax,
        });
    },
    data() {
        return {
            i18nPrefix: 'admin.revenue.revenueTypes',
            LocationLookupType,
            taxList: {} as { [code: string]: ILookupType },
        };
    },
    computed: {
        ...mapState({
            taxes(state: any): RevenueTax[] {
                const loc = state.lookupsModule.locationLookups;
                const types = loc[this.location][LocationLookupType.Tax];
                if (!types) {
                    return [];
                }

                return Object.keys(types).map(taxId => ({ revenueTypeId: 0, taxId: Number.parseInt(taxId, 10) }));
            },
        }),
        entityUrls(): string {
            return `${this.location}/Taxes/RevenueTypes`;
        }
    },
    methods: {
        addRevenueType() {
            this.add();
            Vue.set(this.editItem!, 'revenueTaxes', []);
        },
        afterSave(responseData: AxiosResponse<Revenue>) {
            this.$typedStore.modules.lookupsModule.actions.reloadLocationLookups({
                location: this.location,
                lookupType: LocationLookupType.RevenueType
            });

            return responseData.data;
        },
        afterDelete() {
            this.$typedStore.modules.lookupsModule.actions.reloadLocationLookups({
                location: this.location,
                lookupType: LocationLookupType.RevenueType
            });
        },
    }
});
